<template>
    <VcDropdown max-height="500px" closeOnContentClick>
        <template #activator="{on, attrs}">
        <div v-on="on" v-bind="attrs" data-qa="date-range-select" class="date-range-select d-flex">
            <span>{{ selectedTimeRangeLabel }}</span>
            <VcIcon class="ms-1" :size="16" color="inherit">icon-caret-down</VcIcon>
          </div>
        </template>
        <VcList
            class="time-range-list py-1"
            @select="onTimeRangeSelect"
            :items=timeRangesData>
            <template #default="item">
                <span class="time-range-item">{{ item.label }}</span>
            </template>
        </VcList>
    </VcDropdown>
</template>

<script>
export default {
  name: 'RevenueTimeRangeSelect',
  props: {
    selectedTimeRange: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      timeRangesData: [
        {
          label: this.$t('widget.sales_widget.payment_widget_list.time_range_select.this_week'),
          value: 'WEEK',
          identifier: 0,
        },
        {
          label: this.$t('widget.sales_widget.payment_widget_list.time_range_select.this_month'),
          value: 'MONTH',
          identifier: 1,
        },
        {
          label: this.$t('widget.sales_widget.payment_widget_list.time_range_select.this_year'),
          value: 'YEAR',
          identifier: 2,
        },
      ],
      timeRangesMap: {
        WEEK: 0,
        MONTH: 1,
        YEAR: 2,
      },
    };
  },
  computed: {
    selectedTimeRangeLabel() {
      return this.timeRangesData[this.timeRangesMap[this.selectedTimeRange]].label;
    },
  },
  methods: {
    onTimeRangeSelect(timeRangeIdentifier) {
      this.$emit('time-range-select', this.timeRangesData[timeRangeIdentifier].value);
    },
  },
};
</script>

<style lang="scss" scoped>
.date-range-select:hover {
  color: var(--link-color);
  cursor: pointer;
}
.time-range-item {
  font-size: var(--font-size-x-small);
  font-weight: var(--font-weight-medium2);
}
.time-range-list {
  ::v-deep .vc-base-list-item {
    padding: var(--size-value2) var(--size-value4);
  }
}
</style>
